// extracted by mini-css-extract-plugin
export default {"heading":"Hero_heading__MqxM2","subheading":"Hero_subheading__6NDmk","heroImg":"Hero_heroImg__zb5aB"};